import React, { useEffect } from 'react';
import {
  string, bool, func, shape,
} from 'prop-types';
import { Checkbox } from '@americanexpress/dls-react';
import { useReactlytics } from '@americanexpress/reactlytics';

const RememberMe = ({
  rememberLabel, changeRemember, isRemembered, moduleState,
}) => {
  const { track } = useReactlytics();

  useEffect(() => {
    if (moduleState.userId) {
      changeRemember({ target: { checked: true } });
    } else {
      changeRemember({ target: { checked: false } });
    }

    track({
      event: {
        element: 'Login_RememberMeCheckbox',
        detail: moduleState.userId ? 'checked' : 'unchecked',
        type: 'click',
      },
    });
  }, [moduleState.userId]);

  const onCheck = (event) => {
    changeRemember(event);
    track({
      event: {
        element: 'Login_RememberMeCheckbox',
        detail: event.target.checked ? 'checked' : 'unchecked',
        type: 'click',
      },
    });
  };

  return (
    <Checkbox
      id="rememberMe"
      data-testid="remember-me-checkbox"
      className="checkbox"
      label={rememberLabel}
      onChange={onCheck}
      checked={isRemembered}
      reactlytics={{ disable: true }}
    />
  );
};

RememberMe.propTypes = {
  rememberLabel: string.isRequired,
  changeRemember: func.isRequired,
  isRemembered: bool.isRequired,
  moduleState: shape({}),
};

export default RememberMe;
